import { render, staticRenderFns } from "./TurmasTeoricas.vue?vue&type=template&id=14fbb1e0&scoped=true"
import script from "./TurmasTeoricas.vue?vue&type=script&lang=js"
export * from "./TurmasTeoricas.vue?vue&type=script&lang=js"
import style0 from "./TurmasTeoricas.vue?vue&type=style&index=0&id=14fbb1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fbb1e0",
  null
  
)

export default component.exports